<template>
  <v-row>
    <v-col class="pa-0">
      <v-card class="d-flex flex-column rounded-0" v-if="sender">
        <v-card-title class="primary white--text py-2">
          <v-icon
            v-if="$vuetify.breakpoint.mobile"
            color="white"
            @click="$router.push('/chat')"
            class="mr-6"
            >mdi-arrow-left</v-icon
          >
          <v-avatar size="40" class="mr-2">
            <v-img :src="sender.profilePicture" />
          </v-avatar>
          <div class="d-flex flex-column" style="line-height: 1.4">
            <h5 class="pb-0">{{ sender.senderName }}</h5>
            <small style="font-size: 12px">{{
              isTypeing ? 'Typing...' : sender.status
            }}</small>
          </div>
        </v-card-title>
        <v-card-text
          class="overflow-auto pb-0"
          :style="{
            height: `calc(100vh - (${
              $vuetify.breakpoint.mobile ? '56px' : '64px'
            } + 56px + 56px + ${isIphone10Avobe() ? '34px' : '0px'}))`,
          }"
          ref="chatArea"
        >
          <template v-if="thread.length">
            <div
              class="d-flex mt-5"
              v-for="(message, index) in thread"
              :key="index + message.time"
            >
              <v-avatar
                v-if="message.type === 'replies'"
                class="mr-3"
                size="40"
              >
                <v-img :src="message.avatar" />
              </v-avatar>
              <div
                class="d-flex align-center w-100"
                v-if="message.type === 'replies'"
              >
                <p
                  class="pa-2 mb-0 rounded grey lighten-3"
                  style="max-width: 75%"
                  v-if="message.contentType === 'text'"
                >
                  {{ message.text }}
                </p>

                <p
                  class="pa-2 mb-0 rounded grey lighten-3"
                  style="max-width: 45%"
                  v-if="message.contentType === 'image'"
                >
                  <v-img :src="message.text" />
                </p>

                <p
                  class="pa-2 mb-0 rounded grey lighten-3"
                  style="max-width: 45%"
                  v-if="message.contentType === 'url'"
                >
                  <a
                    :href="message.text"
                    class="body-2 black--text"
                    target="_blank"
                    >File link</a
                  >
                </p>

                <small class="ml-2">{{ message.time }}</small>
              </div>
              <div
                class="d-flex align-center w-100 justify-end"
                v-if="message.type === 'sent'"
              >
                <small class="mr-2">{{ message.time }}</small>
                <p
                  class="pa-2 mb-0 rounded primary white--text text-right"
                  style="max-width: 75%"
                  v-if="message.contentType === 'text'"
                >
                  {{ message.text }}
                </p>
                <p
                  class="pa-2 mb-0 rounded grey lighten-3"
                  style="max-width: 45%"
                  v-if="message.contentType === 'image'"
                >
                  <v-img :src="message.text" />
                </p>
                <p
                  class="pa-2 mb-0 rounded grey lighten-3"
                  style="max-width: 45%"
                  v-if="message.contentType === 'url'"
                >
                  <a
                    :href="message.text"
                    class="body-2 black--text"
                    target="_blank"
                    >File link</a
                  >
                </p>
              </div>
            </div>
          </template>
          <v-alert
            border="bottom"
            class="mt-5"
            colored-border
            type="warning"
            elevation="2"
            v-else
          >
            You don’t have any messages yet
          </v-alert>
        </v-card-text>
        <v-spacer />
        <v-form @submit.prevent="send">
          <v-card-actions>
            <v-btn text fab small class="mr-2" :loading="attachmentLoading">
              <v-icon>mdi-attachment</v-icon>
              <v-file-input
                v-model="attachment"
                @change="attachFileUpload"
                style="position: absolute; opacity: 0"
              />
            </v-btn>
            <v-text-field
              v-model="message"
              placeholder="Message"
              @keyup="amITyping"
              filled
              dense
              rounded
              hide-details
            />
            <v-btn type="submit" color="primary" fab small class="ml-2">
              <v-icon>mdi-message-reply-text</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <v-progress-linear v-else indeterminate />
    </v-col>
  </v-row>
</template>

<script>
import Parse from 'parse'
import PubNubVue from 'pubnub-vue'
import { mapActions, mapGetters } from 'vuex'
import { iPhoneVersion, isIphone } from '../../utils'
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      attachment: null,
      attachmentLoading: false,
      message: '',
      sender: null,
      thread: [],
      isTypeing: false,
      channel: null,
      lastTimeSlow: null,
      pushSent: 0,
      interval: ''
    }
  },
  computed: mapGetters([
    'user',
    'userProfile',
    'updateSubscriptions',
    'messages',
    'globalChannel',
    'pushNotification'
  ]),
  methods: {
    ...mapActions([
      'getUserProfile',
      'getUpdateSubscriptions',
      'getMessages',
      'getMessageCount',
      'getChannelGuys',
      'sendMessageNow',
      'getChannel',
      'sendPushNotification'
    ]),
    isIphone10Avobe () {
      return (
        isIphone() &&
          ['iPhone-X-Xs', 'iPhone-Xmax-Xr', 'iPhone-12'].includes(
            iPhoneVersion()
          )
      )
    },
    amITyping () {
      if (this.message.length) {
        /** it looks like vue js of pubnub doesn't support pubnub.signal */
        //  const inputHasText = this.message.length > 0;
        //  const pubnub = PubNubVue.getInstance();
        //  console.log("Typing....");
        // //  pubnub.signal({
        // //    channel: this.channel,
        // //    message: inputHasText
        // //  });
      }
    },
    gotoBottom () {
      const element = this.$refs.chatArea
      if (typeof element !== 'undefined') {
        element.scrollTop = element.scrollHeight - element.clientHeight
      }
    },
    async handleSend (message) {
      var time = this.$moment().calendar()
      const contentType = this.contentType(message.message)
      var data = {
        text: message.message,
        contentType: contentType,
        type: 'sent',
        name: 'You',
        time: time
      }
      this.thread.push(data)
      /** Push to the server */
      await this.sendMessageNow({
        message: message.message,
        senderId: this.user.id,
        receiverId: this.id,
        senderName:
            this.user.get('firstName') + ' ' + this.user.get('lastName'),
        senderProfilePic: this.user.get('profilePicture'),
        channel: this.channel
      })

      /** is the user offline? send upto 2 push notification */
      if (
        this.pushSent < 2 &&
          typeof this.userProfile.get('deviceId') !== 'undefined' &&
          this.sender.status !== 'Online'
      ) {
        await this.sendPushNotification({
          player_id: this.userProfile.get('deviceId'),
          message: message.message,
          type: 'msg',
          senderId: this.user.id,
          name: this.user.get('firstName') + ' ' + this.user.get('lastName')
        })
        if (this.pushNotification) {
          this.pushSent = Number(this.pushSent + 1)
        }
      }
      this.gotoBottom()
    },
    send () {
      this.handleSend({
        attachment: this.attachment,
        message: this.message
      })
      this.attachment = null
      this.attachmentLoading = false
      this.message = ''
    },
    updateOnlineStatus () {
      const pubnub = PubNubVue.getInstance()
      pubnub.hereNow(
        {
          channels: this.channels,
          includeState: true
        },
        (status, response) => {
          if (response.totalOccupancy > 0 && !status.error) {
            if (
              response.channels[this.channel] &&
                response.channels[this.channel].occupants.length === 2
            ) {
              response.channels[this.channel].occupants.forEach((element) => {
                if (element.uuid !== this.user.id) {
                  this.sender.status = 'Online'
                }
              })
            } else {
              this.sender.status = 'Offline'
            }
          }
        }
      )
    },
    unix_to_pubnub (time) {
      return time * 10000
    },
    update_channel_time (channel, time) {
      localStorage.setItem(channel, time)
    },
    urlOrText (content) {
      var pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$',
        'i'
      )
      return !!pattern.test(content)
    },
    contentType (content) {
      const isValid = this.urlOrText(content)
      if (isValid) {
        var imgExts = ['jpeg', 'jpg', 'png']
        var ext = content.split('.').pop()
        if (imgExts.indexOf(ext) !== -1) {
          return 'image'
        } else {
          return 'url'
        }
      } else {
        return 'text'
      }
    },
    async makeThread (receiverId) {
      this.channel =
          parseInt(this.user.id.charCodeAt(0)) +
          parseInt(receiverId.charCodeAt(0))

      /** Set the channel for global use */
      await this.getChannel({
        channel: this.channel
      })
      const users = [receiverId, this.user.id]
      await this.getUpdateSubscriptions({
        channel: this.channel,
        users
      })
      if (this.updateSubscriptions) {
        /** Once this is done, we can now retreive message history */
        await this.getMessages({
          channel: this.channel,
          max: 50,
          pagesize: 5,
          reverse: false
        })
        if (this.messages.messages.length > 0) {
          this.thread = []
          for (var i = 0; i < this.messages.messages.length; i++) {
            var time = this.$moment
              .unix(parseInt(this.messages.messages[i].timetoken) / 10000000)
              .calendar()

            const contentType = this.contentType(
              this.messages.messages[i].entry.text
            )
            if (this.messages.messages[i].entry.senderId === this.user.id) {
              var data = {
                text: this.messages.messages[i].entry.text,
                contentType: contentType,
                type: 'sent',
                name: this.messages.messages[i].entry.senderName,
                avatar: this.messages.messages[i].entry.senderProfilePic,
                time: time
              }
            } else {
              data = {
                text: this.messages.messages[i].entry.text,
                contentType: contentType,
                type: 'replies',
                name: 'You',
                avatar: this.messages.messages[i].entry.senderProfilePic,
                time: time
              }
            }
            this.thread.push(data)
          }
        }
        /** Update last read message for this channel */
        this.lastTimeSlow = this.unix_to_pubnub(Math.round(+new Date()))
        this.update_channel_time(this.channel, this.lastTimeSlow)
      }
    },
    attachFileUpload () {
      if (this.attachment) {
        this.attachmentLoading = true
        /** Upload the file to the cloud and get the URL */
        var name = this.attachment.name
        name = name.replace(/[ ,]+/g, '-')
        var parseFile = new Parse.File(name, this.attachment)
        parseFile
          .save()
          .then(() => {
            this.message = parseFile._url
            this.attachmentLoading = false
            /** In case of file upload, we don't want to wait for press button, it needs to go immidiately */
            this.send()
          })
          .catch(console.log)
      }
    }
  },
  async created () {
    if (this.id) {
      await this.getUserProfile({
        userId: this.id
      })
      if (this.userProfile) {
        // console.log(this.userProfile.get('deviceId'));
        this.sender = {
          senderName:
              this.userProfile.get('firstName') +
              ' ' +
              this.userProfile.get('lastName'),
          profilePicture: this.userProfile.get('profilePicture'),
          status: 'Offline'
        }
        await this.makeThread(this.id)
        this.gotoBottom()
      }
    }
    // this.sender = this.users.find((user) => user.id === this.id);
  },
  mounted () {
    const pubnub = PubNubVue.getInstance()
    pubnub.addListener({
      message: (m) => {
        if (m.message.receiverId === this.user.id) {
          var pubNubTimeToken = this.unix_to_pubnub(Math.round(+new Date()))
          this.update_channel_time(this.channel, pubNubTimeToken)
          if (m.channel === this.channel) {
            var time = this.$moment().calendar()
            const contentType = this.contentType(m.message.text)
            var data = {
              text: m.message.text,
              contentType: contentType,
              type: 'replies',
              name: m.message.senderName,
              avatar: m.message.senderProfilePic,
              time: time
            }
            this.thread.push(data)
            this.sender.status = 'Online'
            this.gotoBottom()
          }
        }
      },
      presence: (p) => {
        if (p.channel === this.channel && p.uuid !== this.user.id) {
          if (p.action === 'join') {
            this.sender.status = 'Online'
          } else {
            this.sender.status = 'Offline'
          }
        }
      },
      signal: (si) => {
        console.log(si)
        if (si.publisher !== this.user.id) {
          console.log(si.message)
        }
      },
      status: (s) => {
        console.log(s)
      }
    })

    /** Run the status update so we know if the opponent is offline or online */
    this.interval = setInterval(() => this.updateOnlineStatus(), 8000)
  },
  beforeDestroy () {
    // Clear interval
    clearInterval(this.interval)
  }
}
</script>
